import WhIllegalArgumentException from "./WhIllegalArgumentException";

class WhArgumentLengthExceedException extends WhIllegalArgumentException {
    constructor(message) {
        super();
        this.message = message;
    }
}

export default WhArgumentLengthExceedException


// WEBPACK FOOTER //
// ./src/assets/csui/parameter/WhArgumentLengthExceedException.js